import { fetchChallengeGroup } from '@actions/challengeGroups';
import { fetchChallengeHoldersForGroup } from '@actions/challengeGroups/fetchChallengeHoldersForGroup';
import { fetchChallengesForGroup } from '@actions/challenges';
import { useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';

const useFetchChallengeGroupChallenges = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        batch(() => {
            if (!id) return;
            dispatch(fetchChallengeGroup(id));
            dispatch(fetchChallengesForGroup(id));
            dispatch(fetchChallengeHoldersForGroup(id));
        });
    }, [id, dispatch]);
};

export default useFetchChallengeGroupChallenges;
